// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qb-2";
export var chatLink = "_qb-0";
export var chatText = "_qb-1";